import React, { Component} from 'react';



class DefaultCard extends Component {

    constructor(props){

        super(props);

        this.state = {
            request: null,
            total: parseInt(props.pray_total),
            prayed: false,
            actionText: (props.type === 'praise-report') ? 'Celebrate with a 🙌' : 'I Prayed',
            totalText: (props.type === 'praise-report') ? '🙌' : ' people have prayed'
        }
    }

    prayed(){

        // Optimistic Update
        this.setState({total: this.state.total + 1,prayed:true})

        // Dispatch
        this.props.prayed(this.props.id);

    }


    render(){


        return (
            <article className="prayer-request">

                <h6 className="title" dangerouslySetInnerHTML={{__html: this.props.name}} />

                <div className="request" dangerouslySetInnerHTML={{__html: this.props.request}} />

                <div className="controls">

                    <div className="item">
                        <span className="icon icon-users"></span>
                        <span className="text"><b>{this.state.total}</b> {this.state.totalText}</span>
                    </div>

                    {!this.state.prayed && (<a className="item" href="javascript:;" onClick={() => this.prayed()}>
                        <span className="icon icon-user-add"></span>
                        <span className="text">{this.state.actionText}</span>
                    </a>)}
                </div>

            </article>
        );

    }

}

export default DefaultCard;
